import { useTranslation } from 'react-i18next';
import { GroupInfo } from 'ais-facade-api/api';
import styles from './VesselGroupValue.module.scss';
import { Icon } from '../Icon';

export const VesselGroupValue = ({ group }: { group: GroupInfo | null }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.group}>
      {!group ? <Icon name='minus-20' size='20px' color='var(--aux-page-header)' /> : <div className={styles.color_block} style={{ backgroundColor: group?.color }} />}

      <p data-group={group} className={styles.group_label} title={group?.name && group?.name?.length > 20 ? group?.name : undefined}>
        {!group && t('NoGroup')}
        {typeof group?.key === 'string' && group?.name}
      </p>
    </div>
  );
};
